import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const Terms = ({ isTermsChecked, onConfirmationCheckboxChange, isFormSubmit }) => (
  <Content>
    {({
      altBusinessAccountTermsLabel = '',
      altBusinessAccountTermsError = '',
      altBusinessAccountTermsAgreement = ''
    }) => (
      <Field name="altBusinessAccountTerms" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            name="altBusinessAccountTermsAgreement"
            validationMessage={!isTermsChecked && isFormSubmit ? altBusinessAccountTermsError : ''}
          >
            <Field
              name="altBusinessAccountTermsAgreement"
              value={altBusinessAccountTermsAgreement}
              type="checkbox"
            >
              {({ input }) => (
                <StandaloneCheckbox
                  id="altBusinessAccountTermsAgreement"
                  isChecked={isTermsChecked}
                  labelText={altBusinessAccountTermsLabel}
                  onChange={({ isChecked }) => {
                    input.onChange(isChecked);
                    onConfirmationCheckboxChange(isChecked);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default Terms;
